/**
 * Route for `last-click-attribution`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LastClickAttributionPage } from "../features/last-click-attribution/LastClickAttributionPage";

export const lastClickAttributionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/last-click-attribution",
	component: LastClickAttributionPage,
});

export default lastClickAttributionRoute;
